import api from './api';

export interface User {
  id: number;
  username: string;
  email: string;
  full_name: string;
  role: 'admin' | 'pharmacist' | 'assistant';
  is_active: boolean;
  status: 'pending' | 'active' | 'inactive';
  avatar: string | null;
  created_at: string;
  updated_at: string;
}

export interface UsersResponse {
  data: User[];
  pagination: {
    page: number;
    limit: number;
    total: number;
    totalPages: number;
  };
}

export interface GetUsersParams {
  page?: number;
  limit?: number;
  search?: string;
}

export const userService = {
  // Đăng ký user mới (admin)
  register: async (data: {
    username: string;
    email: string;
    password: string;
    full_name: string;
    role: string;
  }) => {
    const response = await api.post('/auth/register', data);
    return response.data;
  },

  // Đổi mật khẩu (user tự đổi)
  changePassword: async (oldPassword: string, newPassword: string) => {
    const response = await api.post('/auth/change-password', { oldPassword, newPassword });
    return response.data;
  },

  // Lấy danh sách users (admin only)
  getUsers: async (params: GetUsersParams = {}): Promise<UsersResponse> => {
    const queryParams = new URLSearchParams();
    if (params.page) queryParams.append('page', params.page.toString());
    if (params.limit) queryParams.append('limit', params.limit.toString());
    if (params.search) queryParams.append('search', params.search);

    const response = await api.get(`/auth/users?${queryParams.toString()}`);
    return response.data;
  },

  // Lấy thông tin user theo ID (admin only)
  getUser: async (id: number): Promise<{ data: User }> => {
    const response = await api.get(`/auth/users/${id}`);
    return response.data;
  },

  // Cập nhật user (admin only)
  updateUser: async (id: number, data: Partial<User>): Promise<{ message: string; data: User }> => {
    const response = await api.put(`/auth/users/${id}`, data);
    return response.data;
  },

  // Reset password (admin only)
  resetPassword: async (userId: number, newPassword: string): Promise<{ message: string }> => {
    const response = await api.post('/auth/admin/reset-password', {
      userId,
      newPassword
    });
    return response.data;
  }
};
